import {
  BriefCampaignInf,
} from "@shared/lib/types/briefCampains";
import {
  IBriefDeliverableConfig,
  IBriefDeliverableTaskConfig,
} from "@shared/lib/types/briefConfig";
import {
  CampaignExecutionTableRow,
  DeliverableDisplayItem,
} from "./executionTypes";

interface BuildExecutionTreeDataParams {
  creators: BriefCampaignInf[];
  config?: IBriefDeliverableConfig[];
  selectedDeliverableId?: string | null;
}

export function buildExecutionTreeData({
  creators,
  config,
  selectedDeliverableId,
}: BuildExecutionTreeDataParams): CampaignExecutionTableRow[] {
  return creators.map((creator) => {
    const allDeliverables = creator?.deliverables || [];
    const creatorDeliverables = selectedDeliverableId
      ? allDeliverables.filter(
          (d) =>
            d._id === selectedDeliverableId ||
            (d as any).deliverableConfigRefId === selectedDeliverableId
        )
      : allDeliverables;

    const childRows: CampaignExecutionTableRow[] = creatorDeliverables.map(
      (deliverable) => {
        const buildconfig = config?.find(
          (c) =>
            c.deliverableConfigRefId === deliverable._id ||
            c.deliverableConfigRefId ===
              (deliverable as any).deliverableConfigRefId
        );

        const tasks: IBriefDeliverableTaskConfig[] =
          buildconfig?.tasks && buildconfig.tasks.length > 0
            ? buildconfig.tasks
            : (deliverable.tasks || []).map((t) => ({
                taskId: t._id,
                name: t.taskName || "Task",
                type: t.type,
                description: "",
                instructions: "",
                uploaderType: [],
                approvalType: [],
                isApprovalRequired: false,
                deadline: "",
              }));

        const deliverableItem: DeliverableDisplayItem = {
          id: deliverable._id,
          name:
            buildconfig?.name || deliverable.deliverableType || "Deliverable",
          isSaved: buildconfig?.isSaved ?? true,
          tasks,
          selectedDeliverable: deliverable,
          parentRecord: creator,
        };

        return {
          ...creator,
          _id: `${creator._id}_del_${deliverable._id}`,
          key: `${creator._id}_del_${deliverable._id}`,
          isDeliverableRow: true,
          deliverableItem,
        };
      }
    );

    if (childRows.length === 1) {
      return {
        ...creator,
        key: creator._id,
        isDeliverableRow: false,
        deliverableItem: childRows[0].deliverableItem,
        children: undefined,
      };
    }

    return {
      ...creator,
      key: creator._id,
      isDeliverableRow: false,
      children: childRows.length > 0 ? childRows : undefined,
    };
  });
}
